import { render, staticRenderFns } from "./CumulativeGraph.vue?vue&type=template&id=a70a2a08&scoped=true&"
import script from "./CumulativeGraph.vue?vue&type=script&lang=js&"
export * from "./CumulativeGraph.vue?vue&type=script&lang=js&"
import style0 from "./CumulativeGraph.vue?vue&type=style&index=0&id=a70a2a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70a2a08",
  null
  
)

export default component.exports